import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import { AppState } from '../../../store/reducers/root';
import { getAvailableApplications } from '../../../store/selectors/session';
import ApplicationSelector from '../../components/session/ApplicationSelector';

type ApplicationSelectorContainerProps = {
  value: string;
  onChange: (app: string) => void;
};

const mapStateToProps = (
  state: AppState,
  { value }: ApplicationSelectorContainerProps
) => ({
  applications: getAvailableApplications(state),
  value,
});

const mapDispatchToProps = (
  _: unknown,
  { onChange }: ApplicationSelectorContainerProps
) => ({
  onChange,
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ApplicationSelectorProps = ConnectedProps<typeof connector>;

export default connector(ApplicationSelector);
